"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderDetailPage = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const order_detail_1 = require("../../sections/order-detail");
const react_router_dom_1 = require("react-router-dom");
const OrderDetailPage = () => {
    const { id } = (0, react_router_dom_1.useParams)();
    return (0, jsx_runtime_1.jsx)(order_detail_1.OrderDetailComponent, { id: id ?? '' });
};
exports.OrderDetailPage = OrderDetailPage;
